define('lib/Podio.UI.Questions',['require','translate','underscore','jquery','lib/Podio.Transport.Questions','lib/Podio.Utils.Text','lib/Podio.Event.UI','lib/Podio.Event','signals'],function(require) {

  var t = require('translate');
  var _ = require('underscore');
  var $ = require('jquery');
  var transportQuestions = require('lib/Podio.Transport.Questions');
  var textUtils = require('lib/Podio.Utils.Text');
  var eventUI = require('lib/Podio.Event.UI');
  var podioEvent = require('lib/Podio.Event');

  var signalsLib = require('signals');

  var inputPlaceholderText = t('Enter a possible answer #questions');
  var clickToCloseText = t('Click to close #questions');
  var templates = {
      answerInput : '<li class="image-block <%= style %>"><div class="img"><label for="<%= id %>"></label></div><div class="img-ext"><div class="delete-question-option icon-16 icon-x-black2"><%= clickToCloseText %></div></div>' +
                    '<div class="bd">' +
                      '<input class="<%= (style != \'last\') ? \'required_group\' : \'\' %>" type="text" placeholder="<%= inputPlaceholderText %>" name="<%= id %>" id="<%= id %>" />' +
                    '</div></li>',
      attachBox : ' <div class="question-attach-box"><div class="question-attach-form"><ul><%- formContent %></ul></div> </div>'
  };

  var signals = {
    onAnswered: new signalsLib.Signal()
  };

  var handlers = {
    onDomReady : function() {

    },

    onAnswerInputFocus: function(elmTarget, e) {
      var totalIndex = $('.question-attach-box input').length;
      var currentIndex = $('.question-attach-box input').index(elmTarget);
      var elmPrevInput = $('.question-attach-box input').eq(currentIndex-1);

      if(!elmPrevInput.val().trim().length || !elmTarget.parents('li').hasClass('last')) {
        return;
      }

      if( currentIndex >= totalIndex -2 ) {
        var html = _.template(templates.answerInput, { count: totalIndex + 1, id : 'question-answer[' + totalIndex + ']', style:'', inputPlaceholderText: inputPlaceholderText, clickToCloseText: clickToCloseText });
        $('.question-attach-box ul').append(html);
      }

      $('.question-attach-box li:last-child').addClass('last').siblings().removeClass('last');
    },

    onDeleteOptionClick:function(elmTarget, e) {
      elmTarget.closest('li').remove();
    },

    onAnswerClick: function(elmTarget, e) {
      var elmQuestionItem = elmTarget.parents('.question-item');
      var elmAnswerItem = elmTarget;

      // Comments and stream in Rails
      var elmGenericCommentWrapper = elmTarget.parents('.commentcontentwrapper');
      if (!elmGenericCommentWrapper.length) {
        elmGenericCommentWrapper = elmTarget.parents('.comment-content-wrapper');
      }

      var elmStreamActivityGroup = elmTarget.parents('.activity.comment');

      var elmStreamObject = elmTarget.parents('.object');
      var elmStatusObject = elmTarget.closest('.permalink-questions');

      // Comments and stream in PHP
      var elmStreamWrapper = elmTarget.parents('.streamwrapper');
      var elmCommentWrapper = elmTarget.parents('.streamcomment');

      var isCompactLayout = false;

      var question_id = elmQuestionItem.data('question-id');
      var question_option_id = elmAnswerItem.data('question-option-id');

      var ref_type, ref_id;

      if(elmGenericCommentWrapper.length) {
        elmCommentWrapper = elmGenericCommentWrapper.parents('.comment');
        if (!elmCommentWrapper.length) {
          elmCommentWrapper = elmGenericCommentWrapper.parents('.comment-new');
        }

        ref_type = elmCommentWrapper.data('ref-type');
        ref_id = elmCommentWrapper.data('comment-id');
        isCompactLayout = elmCommentWrapper.data('compact');

        transportQuestions.answer(question_id, ref_type, ref_id, question_option_id, isCompactLayout, 'comment', function(responseData) {
          elmCommentWrapper.find('.comment_questions').html(responseData.data.html);
        });
      } else if (elmStreamActivityGroup.length) {
        ref_type = elmStreamActivityGroup.data('data-ref-type');
        ref_id = elmStreamActivityGroup.data('data-ref-id');
        var parent_type = elmStreamActivityGroup.data('ref-type');
        var parent_id = elmStreamActivityGroup.data('ref-id');

        // Figure out if the event_types are 'comment' or everything.
        // This is ugly, but this whole file is ugly and I'd rather keep
        // the ugliness here rather than pollute the backbone views/controllers
        // with questions-specific workarounds.
        var event_types;
        if (elmStreamActivityGroup.closest('.activity-group-wrapper').siblings('.activity-header-wrapper').find('.selector .active').data('type') === 'comment') {
          event_types = 'comment';
        }

        transportQuestions.answerActivityGroup(question_id, ref_type, ref_id, question_option_id, parent_type, parent_id, event_types, function(responseData) {
          signals.onAnswered.dispatch(parent_type, parent_id, responseData);
        });

      } else if(elmStatusObject.length) {
        ref_type = elmStatusObject.data('ref-type');
        ref_id = elmStatusObject.data('ref-id');

        transportQuestions.answer(question_id, ref_type, ref_id, question_option_id, isCompactLayout, 'status', function(responseData) {
          elmStatusObject.find('.questions').html(responseData.data.html);
        });
      } else if(elmStreamObject.length) {
        ref_type = elmStreamObject.data('ref-type');
        ref_id = elmStreamObject.data('ref-id');

        transportQuestions.answer(question_id, ref_type, ref_id, question_option_id, isCompactLayout, 'stream', function(responseData) {
          elmStreamObject.replaceWith(responseData.data.html);

          textUtils.initStreamShowOverflow();
        });
      } else {
        ref_type = elmCommentWrapper.length ? elmCommentWrapper.data('ref-type') : elmStreamWrapper.data('ref_type');
        ref_id = elmCommentWrapper.length ? elmCommentWrapper.data('ref-id') : elmStreamWrapper.data('ref_id');

        transportQuestions.answerStream(question_id, ref_type, ref_id, question_option_id, function(responseData) {
          if(elmCommentWrapper.length) {
            elmCommentWrapper.replaceWith(responseData.html);
          } else {
            elmStreamWrapper.replaceWith(responseData.html);
          }
        });
      }

    }
  };

  function renderQuestionBox(elmTarget) {
    var elmEmboxBox = elmTarget.find('.question-attach-box');

    if(elmEmboxBox.length) {
      return;
    }

    var formContent = '';
    _(4).times(function(n) {
     formContent += _.template(templates.answerInput, { count: n+1, id : 'question-answer[' + n + ']', style: (n==3) ? 'last' : '', inputPlaceholderText: inputPlaceholderText, clickToCloseText: clickToCloseText});
    });

    var html = _.template(templates.attachBox, { formContent : formContent });

    elmEmboxBox = $(html);
    elmEmboxBox.appendTo(elmTarget);
  }

  function showAttach(elmEmbedBox, onHideEmbedAttachCallback) {
    if(!elmEmbedBox) {
      return;
    }

    if(_.isFunction(onHideEmbedAttachCallback)) {
      hideAttach.callback = onHideEmbedAttachCallback;
    }

    var elmAttachBox = elmEmbedBox.find('.question-attach-box');
    elmAttachBox.show();
    elmAttachBox.find('input[type=text]').first().val('').focus();
  }

    function hideAttach(elmEmbedBox) {
    if(!elmEmbedBox) {
      return;
    }
    var elmAttachBox = elmEmbedBox.find('.question-attach-box');
    elmAttachBox.remove();

    if( _.isFunction(hideAttach.callback) ) {
      hideAttach.callback();
      hideAttach.callback = null;
    }
  }

  function collectAnswers(elmTarget) {
    var elmEmboxBox = elmTarget.find('.question-attach-box');

    if(!elmEmboxBox.length) {
      return;
    }

    var elmAnswers = elmEmboxBox.find('.question-attach-form input');
    if (!elmAnswers.length) {
      return;
    }

    var answersList = [];
    elmAnswers.each(function(){
      answersList.push($(this).val());
    });
    return answersList;
  }

  podioEvent.bind(podioEvent.Types.init, handlers.onDomReady);
  eventUI.bind('focus', '.question-attach-box input', handlers.onAnswerInputFocus, true);
  eventUI.bind('click', '.question-attach-box li .delete-question-option', handlers.onDeleteOptionClick);
  eventUI.bind('click', '.question-item:not(.app-item) .answer-item', handlers.onAnswerClick);
  eventUI.bind('click', '.question-item:not(.app-item) .answer-item input', $.noop);

  return {
    renderQuestionBox : renderQuestionBox,
    showAttach: showAttach,
    hideAttach: hideAttach,
    collectAnswers: collectAnswers,
    signals: signals
  };

});

